import React from 'react';

import Modal from '/ui/Modal';

import { ModalDetail } from '../utils/modal';

type Props = {
  containerClassName?: string;
};

export default function ModalHolder({ containerClassName = '' }: Props) {
  const [modal, contextHolder] = Modal.useModal();

  React.useEffect(() => {
    const handleMessage = (event: CustomEvent<ModalDetail>) => {
      const { args, type } = event.detail;
      // @ts-ignore
      modal[type](args);
    };

    document?.addEventListener('modalEvent', handleMessage as EventListener);

    return () => {
      document?.removeEventListener(
        'modalEvent',
        handleMessage as EventListener
      );
    };
  }, [modal]);

  return <div className={containerClassName}>{contextHolder}</div>;
}
